// coord-frontend/src/components/conversation/AssistantLoading.js
import React, { useEffect, useState } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import CoordMessageHeader from "./CoordMessageHeader";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";
import { PRIMARY } from "../../styles/colors";

// Status line by time since the wait began (this component mounts when it
// does). Generic on purpose: it never names sources.
export const LOADING_STEPS = [
  { afterMs: 0, text: "Leter etter svaret …" },
  { afterMs: 1500, text: "Setter sammen svaret …" },
  { afterMs: 6000, text: "Bare et øyeblikk til …" },
  { afterMs: 15000, text: "Dette tar litt lengre tid enn vanlig …" },
];

// BeatLoader's geometry (size 8, margin 2) without the animation.
const StillDots = () => (
  <span className="inline-flex">
    {[0, 1, 2].map((i) => (
      <span key={i} className="inline-block h-2 w-2 m-0.5 rounded-full bg-primary" />
    ))}
  </span>
);

// Waiting for an answer: the same header an answer gets (when the previous
// message isn't from Coord), then the dots and the status line — so the
// answer replaces the dots in place.
const AssistantLoading = ({ showHeader = true }) => {
  const [step, setStep] = useState(0);
  const reducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const timers = LOADING_STEPS.slice(1).map(({ afterMs }, i) =>
      setTimeout(() => setStep(i + 1), afterMs)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="flex justify-start">
      <div className="w-full">
        {showHeader && <CoordMessageHeader />}
        <div className="flex items-center gap-3 min-h-6">
          <span aria-hidden="true" className="inline-flex shrink-0">
            {reducedMotion ? <StillDots /> : <BeatLoader color={PRIMARY} size={8} />}
          </span>
          <p role="status" aria-live="polite" className="text-sm text-text-secondary">
            {LOADING_STEPS[step].text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AssistantLoading;
